import { Box, Typography } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import React from 'react';
import type { UserProfileSidebarData } from '../../../../services/types/userProfile.types';

export interface UserProfileSidebarProps {
  data: UserProfileSidebarData;
}

const rowTitleSx = {
  fontSize: '15px',
  fontWeight: 500,
  color: '#FFFFFF',
  textAlign: 'center' as const,
};

const UserProfileSidebar: React.FC<UserProfileSidebarProps> = ({ data }) => {
  return (
    <Box
      className="profile-sidebar"
      sx={{
        background: 'linear-gradient(180deg, #702DFF 0%, #5725C0 100%)',
        minHeight: '100%',
      }}
    >
      <Box mt={5} display="flex" flexDirection="column" alignItems="center" gap={1.5} px={2}>
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: '50%',
            bgcolor: 'rgba(255,255,255,0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          aria-hidden
        >
          <PersonIcon sx={{ fontSize: 40, color: '#FFFFFF' }} />
        </Box>
        <Typography className="profile-avatar-title" sx={{ ...rowTitleSx, fontWeight: 600, fontSize: '16px' }}>
          {data.fullName || 'N/A'}
        </Typography>
        <Typography sx={{ ...rowTitleSx, fontSize: '13.5px', opacity: 0.95 }}>
          {data.designationTitle || 'N/A'}
        </Typography>
      </Box>

      <Box width="100%" px={4} mt={3} mb={2}>
        <Box sx={{ height: '1px', background: 'linear-gradient(90deg, rgba(255,255,255,0) 0%, #FFFFFF 50%, rgba(255,255,255,0) 100%)', opacity: 0.6 }} />
      </Box>

      <Box display="flex" flexDirection="column" alignItems="center" gap={3} px={2} pb={4}>
        <Box textAlign="center">
          <Typography sx={{ fontSize: '12px', color: 'rgba(255,255,255,0.85)', mb: 0.5 }}>Team</Typography>
          <Typography sx={rowTitleSx}>{data.teamName || 'N/A'}</Typography>
        </Box>
        <Box textAlign="center">
          <Typography sx={{ fontSize: '12px', color: 'rgba(255,255,255,0.85)', mb: 0.5 }}>Supervisor</Typography>
          <Typography sx={rowTitleSx}>{data.supervisorLabel}</Typography>
        </Box>
        <Box textAlign="center">
          <Typography sx={{ fontSize: '12px', color: 'rgba(255,255,255,0.85)', mb: 0.5 }}>Direct report</Typography>
          <Typography sx={rowTitleSx}>{data.directReportLabel}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default UserProfileSidebar;
